var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveBoxDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 3C1.94956 3 1.25 3.69956 1.25 4.5625V5.1875C1.25 6.05044 1.94955 6.75 2.8125 6.75H17.1875C18.0504 6.75 18.75 6.05044 18.75 5.1875V4.5625C18.75 3.69956 18.0504 3 17.1875 3H2.8125Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57233 8L3.02214 15.6468C3.09987 16.9682 4.19413 18 5.51782 18H14.4819C15.8056 18 16.8999 16.9682 16.9776 15.6468L17.4274 8H2.57233ZM7.70813 11.125C7.70813 10.7798 7.98795 10.5 8.33313 10.5H11.6665C12.0116 10.5 12.2915 10.7798 12.2915 11.125C12.2915 11.4702 12.0116 11.75 11.6665 11.75H8.33313C7.98795 11.75 7.70813 11.4702 7.70813 11.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveBoxDark);
export default __webpack_public_path__ + "static/media/archive-box-dark.35915b44ae0655af182b6dab2fe96a71.svg";
export { ForwardRef as ReactComponent };